module.exports = __webpack_public_path__ + "static/beauty-box-checkout-e5a4f48d538c92722e35a6daf769aaa3.jpg";